module.exports = __webpack_public_path__ + "static/img/img09_btn.0fc72a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c38/img09_btn.png
// module id = tock
// module chunks = 0